import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Content from "../common/Content";
import { scrollToTop } from "../common/GeneralMethod";
import { useLoading } from "../hooks/useLoading";
import ServiceLevelAgreement from "../Routes/ServiceLevelAgreement";
import PrivacyPolicy from "../Routes/PrivacyPolicy";
import TermsAndConditions from "../Routes/TermsAndConditions";
import RefundPolicy from "../Routes/RefundPolicy";

const Policy = ({apiName,heading}) => {
  const location = useLocation();
  const { startLoading, stopLoading} = useLoading()
  const [policyData, setPolicyData] = useState([]);

  useEffect(() => {
      scrollToTop();
    // const fetchData = async () => {
    //   startLoading()
    //   await axios({
    //     method: "get",
    //     url: process.env.REACT_APP_API_URL + apiName,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then((response) => {
    //       // console.log(response)
    //       setPolicyData([...response.data.data]);
    //       stopLoading()

    //       //console.log(response.data.data);
    //     })
    //     .catch(function (err) {
    //       // console.log(err);
    //       stopLoading()
    //     });
    // };
    // fetchData();
  }, []);

  return (
    <div>
      {/* <Header></Header> */}

      <main>
        <div className="main-content my-5 py-3">
          <div className="privacyPolicy">
            {heading==="Privacy Policy" ? <PrivacyPolicy Header={"No"} />:null}
            {heading==="Terms & Conditions" ? <TermsAndConditions Header={"No"} />:null}
            {heading==="Refund Policy" ? <RefundPolicy Header={"No"} />:null}
            {heading==="ServiceLevelAgreement" ? <ServiceLevelAgreement Header={"No"} />:null}
          </div>
        </div>
      </main>

      {/* <Footer></Footer> */}
      {/* <BackToTop></BackToTop> */}
    </div>
  );
};

export default Policy;
